import { Routes } from '@angular/router';
import { TaalPage } from './Taal/taal.page';
import { authGuard } from './auth.guard';
import { compositionUnsavedChangesGuard } from './composition/composition-unsaved-changes.guard';


export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'composition',
        pathMatch: 'full',
      },
      {
        path: 'taal',
        loadComponent: () =>
          import('./Taal/taal.page').then((m) =>TaalPage),
      },
      {
        path: 'composition',
        loadComponent: () => import('./composition-list/composition-list.page').then((m) => m.CompositionListPage)
      },
      {
        path: 'composition/new',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./composition/composition.page').then((m) => m.CompositionPage)
      },
      {
        path: 'composition/:compositionId',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./composition/composition.page').then((m) => m.CompositionPage)
      },
      {
        path: 'song-composition',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./song-composition/song-composition.page').then((m) => m.SongCompositionPage)
      },
      {
        path: 'song-composition/new',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./song-composition/song-composition.page').then((m) => m.SongCompositionPage)
      },
      {
        path: 'song-composition/new/piece/:pieceId',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./song-composition/song-composition.page').then((m) => m.SongCompositionPage)
      },
      {
        path: 'song-composition/:songCompositionId/piece/:pieceId',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./song-composition/song-composition.page').then((m) => m.SongCompositionPage)
      },
      {
        path: 'song-composition/:songCompositionId',
        canDeactivate: [compositionUnsavedChangesGuard],
        loadComponent: () => import('./song-composition/song-composition.page').then((m) => m.SongCompositionPage)
      },
      {
        path: 'play',
        loadComponent: () => import('./composition-play/composition-play.page').then((m) => m.CompositionPlayPage)
      },
      {
        path: 'play/:compositionId',
        loadComponent: () => import('./composition-play/composition-play.page').then((m) => m.CompositionPlayPage)
      },
      {
        path: 'debug-logs',
        loadComponent: () => import('./debug-logs/debug-logs.page').then((m) => m.DebugLogsPage)
      },
      {
        path: 'synth-check',
        loadComponent: () => import('./synth-check/synth-check.page').then((m) => m.SynthCheckPage)
      },
      {
        path: 'synthCheck',
        loadComponent: () => import('./synth-check/synth-check.page').then((m) => m.SynthCheckPage)
      },
      {
        path: 'sf2-synth-check',
        loadComponent: () => import('./sf2-synth-check/sf2-synth-check.page').then((m) => m.Sf2SynthCheckPage)
      },
      {
        path: 'sf2SynthCheck',
        loadComponent: () => import('./sf2-synth-check/sf2-synth-check.page').then((m) => m.Sf2SynthCheckPage)
      }
    ]
  },
  {
    path: 'user',
    loadComponent: () => import('./user/user.page').then((m) => m.UserPage)
  },
  {
    path: 'share',
    loadComponent: () => import('./composition-share/composition-share.page').then((m) => m.CompositionSharePage)
  },
  {
    path: 'share/:shareId',
    loadComponent: () => import('./composition-share/composition-share.page').then((m) => m.CompositionSharePage)
  },
  {
    path: 'about',
    loadComponent: () => import('./info/info.page').then((m) => m.InfoPage)
  },
  {
    path: 'help',
    loadComponent: () => import('./info/info.page').then((m) => m.InfoPage)
  },
  {
    path: 'lrcgen',
    loadComponent: () => import('./info/info.page').then((m) => m.InfoPage)
  },
  {
    path: 'support',
    loadComponent: () => import('./info/info.page').then((m) => m.InfoPage)
  }
];
